export const IMPORTER_LIST = 'IMPORTER_LIST'
export const IMPORTER_INFO = 'IMPORTER_INFO'
export const IMPORTER_VALIDATION = 'IMPORTER_VALIDATION'
export const IMPORTER_ADD = 'IMPORTER_ADD'
